import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { StoreModule } from '@ngrx/store';
import { counterReducer } from './redux/counter.reducer';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
  AccordionModule,
  SharedModule,
  ModalModule,
  ButtonModule,
  TableModule,
  UtilitiesModule,
  DropdownModule,
} from '@coreui/angular';
import { MatTableModule } from '@angular/material/table'
import { NgxOtpInputModule } from 'ngx-otp-input';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { FooterComponent } from './components/footer/footer.component';
import { MarketPlaceComponent } from './pages/market-place/market-place.component';
import { CommunityComponent } from './pages/community/community.component';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { RegisterAlertComponent } from './components/register-alert/register-alert.component';
import { RegisterComponent } from './pages/register/register.component';
import { InputBoxComponent } from './components/common-form-fields/input-box/input-box.component';
import { SelectBoxComponent } from './components/common-form-fields/select-box/select-box.component';
import { MainHeadingComponent } from './components/main-heading/main-heading.component';
import { SuccessStoriesComponent } from './components/community-components/success-stories/success-stories.component';
import { SuccessStoriesHerstoreComponent } from './components/sell-on-her-store-components/success-stories-herstore/success-stories.component';
import { UpSkillComponent } from './components/community-components/up-skill/up-skill.component';
import { TopCategoriesComponent } from './components/market-place-components/top-categories/top-categories.component';
import { TopPicksComponent } from './components/market-place-components/top-picks/top-picks.component';
import { BuyerTestimonialsComponent } from './components/market-place-components/buyer-testimonials/buyer-testimonials.component';
import { TopSellerComponent } from './components/market-place-components/top-seller/top-seller.component';
import { BusinessNearComponent } from './components/market-place-components/business-near/business-near.component';
import { ServiceNearComponent } from './components/market-place-components/service-near/service-near.component';
import { NewArrivalsComponent } from './components/market-place-components/new-arrivals/new-arrivals.component';
import { PopularProductComponent } from './components/market-place-components/popular-product/popular-product.component';
import { MarketTrustComponent } from './components/market-place-components/market-trust/market-trust.component';
import { MarketComponent } from './components/market-place-components/market/market.component';
import { GroceryComponent } from './components/market-place-components/shops/grocery/grocery.component';
import { HomeCooksComponent } from './components/market-place-components/shops/home-cooks/home-cooks.component';
import { HandicraftComponent } from './components/market-place-components/shops/handicraft/handicraft.component';
import { GiftComponent } from './components/market-place-components/shops/gift/gift.component';
import { HomeAndLifestyleComponent } from './components/market-place-components/shops/home-and-lifestyle/home-and-lifestyle.component';
import { HealthPersonalComponent } from './components/market-place-components/shops/health-personal/health-personal.component';
import { HeroBannerComponent } from './components/hero-banner/hero-banner.component';
import { CardWithIconComponent } from './components/cards/card-with-icon/card-with-icon.component';
import { CategoryCardComponent } from './components/cards/category-card/category-card.component';
import { SellerCardComponent } from './components/cards/seller-card/seller-card.component';
import { MentorComponent } from './components/community-components/mentor/mentor.component';
import { ForumComponent } from './components/community-components/forum/forum.component';
import { LatestArticleComponent } from './components/community-components/latest-article/latest-article.component';
import { BeAPartComponent } from './components/community-components/be-a-part/be-a-part.component';
import { RegisterBusinessDetailComponent } from './pages/register-business-detail/register-business-detail.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterBannerComponent } from './components/register-components/register-banner/register-banner.component';
import { LoginDetailsComponent } from './components/register-components/login-details/login-details.component';
import { PersonalDetailsComponent } from './components/register-components/personal-details/personal-details.component';
import { BusinessDetailsComponent } from './components/register-components/business-details/business-details.component';
import { BusinessDocumentsComponent } from './components/register-components/business-documents/business-documents.component';
import { languageReducer } from './redux/language/language.reducer';
import { SellOnHerStoreComponent } from './pages/sell-on-her-store/sell-on-her-store.component';
import { WhatHerStoreComponent } from './components/sell-on-her-store-components/what-her-store/what-her-store.component';
import { BenefitsComponent } from './components/sell-on-her-store-components/benefits/benefits.component';
import { RegisterYourStoreComponent } from './components/sell-on-her-store-components/register-your-store/register-your-store.component';
import { BePartCommunityComponent } from './components/sell-on-her-store-components/be-part-community/be-part-community.component';
import { FaqHerstoreComponent } from './components/sell-on-her-store-components/faq-herstore/faq-herstore.component';
import { TermsConditionsComponent } from './pages/terms-conditions/terms-conditions.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { BannerFooterPagesComponent } from './components/banner-footer-pages/banner-footer-pages.component';
import { FaqContentComponent } from './components/faq-content/faq-content.component';
import { FaqComponent } from './pages/faq/faq.component';
import { BannerInnerPagesComponent } from './components/banner-inner-pages/banner-inner-pages.component';
import { SidemenuFaqComponent } from './components/sidemenu-faq/sidemenu-faq.component';
import { ContactComponent } from './pages/contact/contact.component';
import { PolicyComponent } from './pages/policy/policy.component';
import { DisclaimersComponent } from './pages/disclaimers/disclaimers.component';
import { AboutComponent } from './pages/about/about.component';
import { SitemapComponent } from './pages/sitemap/sitemap.component';
import { WishlistComponent } from './pages/wishlist/wishlist.component';
import { PersonalInfoComponent } from './pages/personal-info/personal-info.component';
import { BannerProfileComponent } from './components/banner-profile/banner-profile.component';
import { AddressBookComponent } from './pages/address-book/address-book.component';
import { AddressCardComponent } from './components/cards/address-card/address-card.component';
import { BusinessInformationComponent } from './pages/business-information/business-information.component';
import { ComplianceSellerComponent } from './pages/compliance-seller/compliance-seller.component';
import { BusinessDescriptionSellerComponent } from './pages/business-description-seller/business-description-seller.component';
import { TagInputComponent } from './components/tag-input/tag-input.component';
import { BusinessValidationListingComponent } from './pages/business-validation-listing/business-validation-listing.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MAT_DATE_LOCALE, MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { SwiperDirectiveDirective } from './swiper-directive.directive';
import { CustomNotificationComponent } from './components/custom-notification/custom-notification.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CustomCarouselComponent } from './components/custom-carousel/custom-carousel.component';
import { CategoryListComponent } from './pages/category-list/category-list.component';
import { SellerProfileProductComponent } from './pages/seller-profile-product/seller-profile-product.component';
import { SellerProfileServiceComponent } from './pages/seller-profile-service/seller-profile-service.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CookiePolicyComponent } from './pages/cookie-policy/cookie-policy.component';
import { ClickOutsideDirective } from './clickOutside.directive';
import { SellerAgreementComponent } from './pages/seller-agreement/seller-agreement.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { AdminPanelComponent } from './pages/admin-panel/admin-panel.component';
import { WriteArticleComponent } from './pages/write-article/write-article.component';
import { ValidationDetailComponent } from './pages/validation-detail/validation-detail.component';
import { ProductListingComponent } from './pages/product-listing/product-listing.component';
import { BusinessValidationComponent } from './pages/business-validation/business-validation.component';
import { ValidationListingComponent } from './pages/validation-listing/validation-listing.component';
import { ApproveValidationComponent } from './pages/approve-validation/approve-validation.component';
import { AdminProductListingComponent } from './pages/admin-product-listing/admin-product-listing.component';
import { ServiceValidationComponent } from './pages/service-validation/service-validation.component';
import { SellerApproveComponent } from './pages/seller-approve/seller-approve.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { PaginationComponent } from './components/pagination/pagination.component';
import { EditProductComponent } from './components/products/edit-product/edit-product.component';
import { ValidationPageBComponent } from './pages/validation-page-b/validation-page-b.component';
import { ValidationPageCComponent } from './pages/validation-page-c/validation-page-c.component';
import { AddProductComponent } from './components/products/add-product/add-product.component';
import { ServiceListingComponent } from './pages/service-listing/service-listing.component';
import { LocalBusinessManagerComponent } from './pages/local-business-manager/local-business-manager.component';
import { AddServiceComponent } from './components/services/add-service/add-service.component';
import { EditServiceComponent } from './components/services/edit-service/edit-service.component';
import { AddLocalBusinessProductComponent } from './components/local-business-manager/add-local-business-product/add-local-business-product.component';
import { EditLocalBusinessProductComponent } from './components/local-business-manager/edit-local-business-product/edit-local-business-product.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import {
  NgxExtendedPdfViewerComponent,
  NgxExtendedPdfViewerModule,
} from 'ngx-extended-pdf-viewer';
import { FaqMasterComponent } from './pages/faq-master/faq-master.component';
import { EntityTypesComponent } from './pages/entity-types/entity-types.component';
import { StateMasterComponent } from './pages/state-master/state-master.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CustomPdfViewComponent } from './components/custom-pdf-view/custom-pdf-view.component';
import { DatePipe, registerLocaleData } from '@angular/common';
import {MatAccordion, MatExpansionModule} from '@angular/material/expansion';

import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { ValidationDashboardComponent } from './pages/validation-dashboard/validation-dashboard.component';
import { ValidationDashDetailsComponent } from './pages/validation-dash-details/validation-dash-details.component';
import { SnapshotFilterComponent } from './components/validation/snapshot-filter/snapshot-filter.component';
import { RegistrationFilterComponent } from './components/validation/registration-filter/registration-filter.component';
import { AlertModalComponent } from './components/alert-modal/alert-modal.component';

import localeEn from '@angular/common/locales/en';


registerLocaleData(localeEn);



@NgModule({
  declarations: [
    AppComponent,

    HeaderComponent,
    FooterComponent,
    MarketPlaceComponent,
    CommunityComponent,
    HomepageComponent,
    // RegisterAlertComponent,
    MainHeadingComponent,
    SuccessStoriesComponent,
    SuccessStoriesHerstoreComponent,
    UpSkillComponent,
    RegisterComponent,
    InputBoxComponent,
    SelectBoxComponent,
    MainHeadingComponent,
    TopCategoriesComponent,
    TopPicksComponent,
    BuyerTestimonialsComponent,
    TopSellerComponent,
    BusinessNearComponent,
    ServiceNearComponent,
    NewArrivalsComponent,
    PopularProductComponent,
    MarketTrustComponent,
    MarketComponent,
    GroceryComponent,
    HomeCooksComponent,
    HandicraftComponent,
    GiftComponent,
    HomeAndLifestyleComponent,
    HealthPersonalComponent,
    HeroBannerComponent,
    CardWithIconComponent,
    CategoryCardComponent,
    SellerCardComponent,
    MentorComponent,
    ForumComponent,
    LatestArticleComponent,
    BeAPartComponent,
    RegisterBusinessDetailComponent,
    LoginComponent,
    RegisterBannerComponent,
    LoginDetailsComponent,
    PersonalDetailsComponent,
    BusinessDetailsComponent,
    BusinessDocumentsComponent,
    SellOnHerStoreComponent,
    WhatHerStoreComponent,
    BenefitsComponent,
    RegisterYourStoreComponent,
    BePartCommunityComponent,
    FaqHerstoreComponent,
    TermsConditionsComponent,
    SideMenuComponent,
    BannerFooterPagesComponent,
    FaqContentComponent,
    FaqComponent,
    BannerInnerPagesComponent,
    SidemenuFaqComponent,
    ContactComponent,
    PolicyComponent,
    DisclaimersComponent,
    AboutComponent,
    SitemapComponent,
    WishlistComponent,
    PersonalInfoComponent,
    BannerProfileComponent,
    AddressBookComponent,
    AddressCardComponent,
    BusinessInformationComponent,
    ComplianceSellerComponent,
    BusinessDescriptionSellerComponent,
    TagInputComponent,
    BusinessValidationListingComponent,
    SwiperDirectiveDirective,
    CustomNotificationComponent,
    CustomCarouselComponent,
    CategoryListComponent,
    SellerProfileProductComponent,
    SellerProfileServiceComponent,
    CookiePolicyComponent,
    ClickOutsideDirective,
    SellerAgreementComponent,
    AdminPanelComponent,
    WriteArticleComponent,
    ValidationDetailComponent,
    ProductListingComponent,
    BusinessValidationComponent,
    ValidationListingComponent,
    ApproveValidationComponent,
    AdminProductListingComponent,
    ServiceValidationComponent,
    SellerApproveComponent,
    PaginationComponent,
    EditProductComponent,
    AddProductComponent,
    ValidationPageBComponent,
    ValidationPageCComponent,
    ServiceListingComponent,
    LocalBusinessManagerComponent,
    AddServiceComponent,
    EditServiceComponent,
    AddLocalBusinessProductComponent,
    EditLocalBusinessProductComponent,
    FaqMasterComponent,
    EntityTypesComponent,
    StateMasterComponent,
    CustomPdfViewComponent,
    ValidationDashboardComponent,
    ValidationDashDetailsComponent,
    SnapshotFilterComponent,
    RegistrationFilterComponent,
    AlertModalComponent
  ],
  imports: [
    NgxPaginationModule,
    CarouselModule,
    DropdownModule,
    BrowserModule,
    TableModule,
    UtilitiesModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    AccordionModule,
    SharedModule,
    ModalModule,
    ButtonModule,
    ReactiveFormsModule,
    FormsModule,
    NgxOtpInputModule,
    StoreModule.forRoot({ count: counterReducer }, {}),
    StoreModule.forRoot({ language: languageReducer }, {}),
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatFormFieldModule,
    BrowserAnimationsModule,
    MatRippleModule,
    MatSelectModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    PdfViewerModule,
    NgxExtendedPdfViewerModule,
    SlickCarouselModule,
    NgxDocViewerModule,
    NgbDatepickerModule,
    NgxDaterangepickerMd.forRoot(),
    MatTableModule,
    MatExpansionModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'en-US' },
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    MatDatepickerModule,
    DatePipe
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
